/**
 * Geometry and colour for the full-size Nova mascot on the live (voice) screen,
 * taken from the Nova Studio reference (the "Original Nova" shape, Nova theme).
 * Units are the reference's: the body sits in a 250-unit box centred on 0,0.
 */
export const MASCOT_VIEWBOX = '-125 -125 250 250';
export const MASCOT_UNITS = 250;

export const MASCOT_BODY_PATH =
  'M77.29 -0.41C77.01 2.15 77.05 4.66 76.79 7.19C76.53 9.71 76.19 12.23 75.74 14.73C75.29 17.23 74.76 19.72 74.11 22.18C73.47 24.65 72.72 27.1 71.86 29.51C71.01 31.92 70.05 34.32 68.97 36.66C67.89 38.99 66.7 41.3 65.4 43.54C64.09 45.77 62.67 47.97 61.14 50.07C59.6 52.17 57.94 54.21 56.18 56.15C54.42 58.08 52.55 59.93 50.57 61.67C48.6 63.4 46.52 65.03 44.36 66.53C42.21 68.03 39.94 69.42 37.63 70.67C35.31 71.92 32.91 73.04 30.47 74.03C28.03 75.01 25.53 75.86 23 76.58C20.47 77.31 17.9 77.89 15.32 78.36C12.73 78.82 10.12 79.16 7.51 79.38C4.9 79.61 2.27 79.71 -0.34 79.71C-2.96 79.71 -5.59 79.61 -8.2 79.38C-10.81 79.16 -13.42 78.82 -16 78.36C-18.59 77.89 -21.16 77.31 -23.69 76.58C-26.21 75.86 -28.72 75.01 -31.16 74.03C-33.6 73.04 -36 71.92 -38.32 70.67C-40.63 69.42 -42.89 68.03 -45.05 66.53C-47.21 65.03 -49.29 63.4 -51.26 61.67C-53.23 59.93 -55.11 58.08 -56.87 56.15C-58.63 54.21 -60.29 52.17 -61.82 50.07C-63.36 47.97 -64.78 45.77 -66.09 43.54C-67.39 41.3 -68.58 38.99 -69.66 36.65C-70.74 34.32 -71.7 31.92 -72.55 29.51C-73.41 27.1 -74.15 24.65 -74.8 22.18C-75.44 19.72 -75.98 17.23 -76.43 14.73C-76.88 12.23 -77.22 9.71 -77.48 7.19C-77.74 4.66 -77.7 2.15 -77.98 -0.41C-78.27 -2.98 -78.68 -5.51 -79.19 -8.18C-79.7 -10.86 -80.33 -13.57 -81.04 -16.47C-81.75 -19.38 -82.78 -22.46 -83.44 -25.64C-84.1 -28.81 -85.35 -32.49 -85.01 -35.5C-84.66 -38.52 -83.35 -41.49 -81.35 -43.74C-79.36 -45.99 -76.02 -47.6 -73.05 -49.03C-70.09 -50.46 -66.36 -51.11 -63.55 -52.32C-60.74 -53.53 -58.43 -54.83 -56.19 -56.29C-53.96 -57.76 -52.11 -59.45 -50.15 -61.13C-48.18 -62.82 -46.33 -64.58 -44.41 -66.41C-42.5 -68.23 -40.6 -70.09 -38.64 -72.1C-36.68 -74.12 -34.73 -76.18 -32.67 -78.5C-30.61 -80.81 -28.54 -83.23 -26.29 -85.98C-24.03 -88.72 -21.77 -92 -19.14 -94.96C-16.51 -97.92 -13.65 -101.8 -10.51 -103.73C-7.38 -105.66 -3.73 -106.54 -0.34 -106.54C3.05 -106.54 6.69 -105.66 9.83 -103.73C12.96 -101.8 15.82 -97.92 18.45 -94.96C21.08 -92 23.34 -88.72 25.6 -85.98C27.85 -83.23 29.92 -80.81 31.98 -78.5C34.04 -76.18 35.99 -74.12 37.95 -72.1C39.91 -70.09 41.81 -68.23 43.72 -66.41C45.64 -64.58 47.49 -62.82 49.46 -61.13C51.42 -59.45 53.27 -57.76 55.5 -56.29C57.74 -54.83 60.05 -53.53 62.86 -52.32C65.67 -51.11 69.4 -50.46 72.37 -49.03C75.33 -47.6 78.67 -45.99 80.67 -43.74C82.66 -41.49 83.97 -38.52 84.32 -35.5C84.67 -32.49 83.41 -28.81 82.75 -25.64C82.09 -22.46 81.06 -19.38 80.35 -16.47C79.64 -13.57 79.01 -10.86 78.5 -8.18C77.99 -5.51 77.58 -2.98 77.29 -0.41Z';

/** Where the body rests on the ground; squash and bounce pivot here. */
export const MASCOT_FOOT_Y = 80;

/** Eye centres and resting size (the reference's 13.13 × 25.32 radii). */
export const MASCOT_EYES = [
  { cx: -28.86, cy: 8.53 },
  { cx: 34.87, cy: 7.32 },
] as const;
export const MASCOT_EYE = { w: 26.3, h: 50.6 } as const;

export const MASCOT_COLORS = {
  bodyTop: '#E8E3FA',
  bodyMid: '#B8A3FF',
  bodyBottom: '#7A52FE',
  glow: '#7DE7FF',
  outline: '#A798E8',
  eyeTop: '#FFFFFF',
  eyeBottom: '#D8E1F5',
  dotA: '#97ECFE',
  dotB: '#B8A3FF',
  dotC: '#8D74F7',
  dotD: '#5B3DE1',
  bubble: '#DCD3FD',
  bubbleDot: '#8D74F7',
  ground: '#91ACD9',
} as const;

/** Listening ring: the dots orbit the body's waist, the far half passes behind it. */
export const RING_DOTS = 36;
export const RING = { rx: 113, cy: 34, ry: 16, wave: 7.5, dot: 3.4 } as const;

/**
 * Thinking: a chat bubble with three dots, trailed by two small bubbles that
 * step down toward the ground. Measured off the reference's thinking frames
 * (pill 103px wide → 150 units): it sits at the body's middle, not above it.
 */
export const BUBBLE = { w: 150, h: 56, y: 2, dotGap: 31, dotR: 7.4 } as const;
export const BUBBLE_TRAIL = [
  { cx: -53, cy: 59, r: 7.3 },
  { cx: -69, cy: 76, r: 4.4 },
] as const;

/** Blink timing (seconds): one every cycle, a double on every third. */
export const BLINK = { cycle: 3.7, duration: 0.18, second: 0.3, minOpen: 0.06 } as const;
